const HELP_TEXTS = {
  actionButtons: {
    exportInvoices:
      'An exhaustive export of this list will be sent to you shortly by Email. It can take a few minutes for the Email to be sent.',
    editInvoice:
      'An invoice can be edited by (S)PCs and SBO only if Invoice Status is Draft or Changes Requested.',
  },
};

export default HELP_TEXTS;
